import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-informations',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './informations.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./informations.component.scss']
})
export class InformationsComponent {

}